import type { Ssm5ModuleStatus } from '@packages/domain/ssm5';

import { useTranslation } from 'react-i18next';

import { STATUS_LOOKS } from '../helpers/diagram-modules';
import { ssm5ControlStyles, ssm5TextStyles } from '../ssm5.styles';
import { Ssm5IconBadge } from './ssm5-icon-badge';

/** Props for {@link Ssm5ModuleStatusChip}. */
export type Ssm5ModuleStatusChipProps = {
    /** The status the chip names. */
    status: Ssm5ModuleStatus;
};

/**
 * The chip of a module status: its icon and label on the badge of its color, as the legend and the
 * module header draw it.
 *
 * @param props - {@link Ssm5ModuleStatusChipProps}
 * @returns the chip
 */
export function Ssm5ModuleStatusChip({ status }: Ssm5ModuleStatusChipProps) {
    const { t } = useTranslation();
    const { chip } = STATUS_LOOKS[status];

    return (
        <Ssm5IconBadge
            icon={chip.icon}
            iconColor={chip.iconColor}
            style={ssm5ControlStyles.legendChip}
            textStyle={ssm5TextStyles.legendChipText}
            variant={chip.variant}
        >
            {t(chip.labelKey)}
        </Ssm5IconBadge>
    );
}
